<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button v-if="back" class="btn-back" @click="$router.go(-1)">Back</ion-button>
          <ion-button v-if="!back" class="btn-back" @click="$router.back()">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="1"></bg>
      <ion-grid>
        <form @submit="save" class="row-boxed mt-20">
          <ion-row class="mb-20">
            <ion-col size="12" class="text-right">
              <ion-button @click="loadTemplate" type="button">LOAD TEMPLATE</ion-button>
            </ion-col>
          </ion-row>
          <div class="fix-padded">
            <nested-draggable :k="0" @add="(i) => add(i)" :indices="workListIndices" type="worklist" v-if="workListIndices"></nested-draggable>
          </div>

          <ion-row>
            <ion-col size="12" class="text-right">
              <ion-button @click="saveTemplate" type="button">SAVE AS TEMPLATE</ion-button>
              <ion-button type="submit">SAVE</ion-button>
            </ion-col>
          </ion-row>
          <!-- Permette l'invio del form con tasto enter -->
          <input type="submit" class="hidden">
        </form>

      </ion-grid>

      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios";
import nestedDraggable from "./partials/Nested";
import Vue from "vue";

export default {
  name: "WorklistEdit",
  components: {
    nestedDraggable
  },
  data: function () {
    return {
      workListIndices: [],
      templates: [],
      back: this.$route.params.back ? this.$route.params.back : false,
      loader: false,
    }
  },
  computed: {
    workListsSave: function(){
      let workLists = JSON.parse(JSON.stringify(this.workListIndices))
      let workListsSave = []
      workListsSave = workListsSave.concat(this.splitWorkLists(workLists, ''))
      return workListsSave
    }
  },
  methods: {
    splitWorkLists: function(arrayLoop, parent){
      let workListsSave = []
      if(arrayLoop.length) {
        let x = 0
        while (x < arrayLoop.length) {
          arrayLoop[x].parent = parent
          workListsSave.push(arrayLoop[x])
          if(arrayLoop[x].indices.length) {
            parent = arrayLoop[x].ref_number
            workListsSave = workListsSave.concat(this.splitWorkLists(arrayLoop[x].indices, parent))
            parent = ''
          }
          x++
        }
      }
      return workListsSave
    },
    checkRefNumber() {
      let i = 0
      let error = false
      while (i < this.workListsSave.length) {
        if(!this.workListsSave[i].ref_number) {
          error = true
        }
        i++
      }
      return error
    },
    async save(ev) {
      ev.preventDefault();
      if(!this.checkRefNumber()) {
        this.loader = true;
        axios.post(this.apiUrl + '/api/v1/save-worklists', {
          api_token: this.$store.state.api_token,
          indices: this.workListsSave,
          report_id: this.$route.params.id
        })
            .then(async (response) => {
              let res = response.data
              if (res.data) {
                const toast = await this.$ionic.toastController.create({
                  message: 'Work list index updated succesfully',
                  color: 'success',
                  position: 'bottom',
                  duration: 2000
                })
                await toast.present();
              }
              this.loader = false;
            })
        } else {
          const toast = await this.$ionic.toastController.create({
            message: '"Ref Number" is required in all indices',
            color: 'danger',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
        }
    },
    loadTemplate() {
      let inputs = []
      let i = 0
      while (i < this.templates.length) {
        let obj = {
          type: 'radio',
          value: this.templates[i].template,
          label: this.templates[i].template,
        }
        inputs.push(obj)
        i++
      }

      return this.$ionic.alertController
        .create({
          header: 'Choose a template',
          inputs: inputs,
          buttons: [
            {
              text: 'Back',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                // this.$router.back()
              },
            },
            {
              text: 'Import',
              handler: (value) => {
                this.loader = true
                axios.post(this.apiUrl + '/api/v1/get-worklist-indices', { api_token: this.$store.state.api_token, name: value })
                  .then((response) => {
                    this.workListIndices = []
                    let res = response.data
                    if(res.data.length) {
                      let i = 0
                      while (i < res.data.length) {
                        res.data[i].id = ''
                        res.data[i].yacht_id = ''
                        res.data[i].template = ''
                        delete res.data[i].created_at
                        delete res.data[i].updated_at
                        Vue.set(this.workListIndices, this.workListIndices.length, res.data[i]);
                        i++
                      }
                    } else {
                      // Non sono presenti indici, creo una riga vuota
                      this.add()
                    }
                    this.loader = false
                  })

              },
            },
          ]
        })
        .then(a => a.present())
    },
    saveTemplateApi(name) {
      this.loader = true;
      axios.post(this.apiUrl + '/api/v1/save-worklist-template', { api_token: this.$store.state.api_token, indices: this.workListsSave, name: name })
        .then(async(response) => {
          let res = response.data
          if(res.status == 1) {
            const toast = await this.$ionic.toastController.create({
              message: 'Template saved succesfully',
              color: 'success',
              position: 'bottom',
              duration: 2000
            })
            await toast.present();
          }
          this.loader = false;

          const toast = await this.$ionic.toastController.create({
            message: 'Template saved succesfully',
            color: 'success',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
        })
    },
    async saveTemplate() {
      if(!this.checkRefNumber()) {
        return this.$ionic.alertController
          .create({
            header: 'Save template',
            inputs: [
              {
                name: 'name',
                id: 'name',
                placeholder: 'Template name',
              },
            ],
            buttons: [
              {
                text: 'Back',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                  // this.$router.back()
                },
              },
              {
                text: 'Save',
                handler: async(value) => {
                  let name = value.name
                  if(name) {
                    this.loader = true;
                    axios.post(this.apiUrl + '/api/v1/check-template-worklist-name', { api_token: this.$store.state.api_token, name: name })
                      .then(async(response) => {
                        let res = response.data
                        if(res.data.exist == 1) {
                          return this.$ionic.alertController
                            .create({
                              header: 'A template with the same name already exists. Do you want to overwrite it?',
                              buttons: [
                                {
                                  text: 'No',
                                  role: 'cancel',
                                  cssClass: 'secondary',
                                  handler: async() => {
                                    this.loader = false
                                  },
                                },
                                {
                                  text: 'Yes',
                                  handler: async() => {
                                    this.saveTemplateApi(name)
                                  },
                                },
                              ],
                            })
                            .then(a => a.present())
                        } else {
                          this.saveTemplateApi(name)
                        }
                      })
                  } else {
                    const toast = await this.$ionic.toastController.create({
                      message: 'Template name is required',
                      color: 'danger',
                      position: 'bottom',
                      duration: 3000
                    })
                    await toast.present();
                    this.insert()
                  }
                },
              },
            ],
          })
          .then(a => a.present())
      } else {
        const toast = await this.$ionic.toastController.create({
          message: '"ref number" required in all indices',
          color: 'danger',
          position: 'bottom',
          duration: 2000
        })
        await toast.present();
      }
    },
    add() {
      let obj = {
        id: '',
        report_id: '',
        ref_number: '',
        title: '',
        parent: '',
        order: '',
        user_id_added: '',
        user_id_edited: '',
        indices: [],
      }
      Vue.set(this.workListIndices, this.workListIndices.length, obj);
    }

  },
  mounted: async function () {
    await axios.post(this.apiUrl + '/api/v1/get-worklists', {
      api_token: this.$store.state.api_token,
      id: this.$route.params.id
    })
      .then((response) => {
        let res = response.data
        if (res.data.length) {
          let i = 0
          while (i < res.data.length) {
            Vue.set(this.workListIndices, this.workListIndices.length, res.data[i]);
              console.log(res.data[i])
            i++
          }
        } else {
          // Non sono presenti indici, creo una riga vuota
          this.add()
        }
      })

    await axios.post(this.apiUrl + '/api/v1/get-worklist-templates', { api_token: this.$store.state.api_token })
      .then((response) => {
        let res = response.data
        if(res.data) {
          this.templates = res.data
        }
      })
  }
};
</script>